// extracted by mini-css-extract-plugin
export default {"tooltip_menu":"Tooltip_tooltip_menu__yID-J","backdrop":"Tooltip_backdrop__zMTew"};